export default __webpack_public_path__ + "static/media/3031 knife block A side.066b30eb.png";